import { Box, Stack, Tooltip, Typography } from "@mui/material";

function InfoCard({ title, rows }) {
  const getDisplayValue = (value) => {
    if (value === null || value === undefined || value === "0") return "-";
    return value;
  };

  const highlightRow = rows.find((row) => row.highlight);
  const normalRows = rows.filter((row) => !row.highlight);

  return (
    <Stack
      sx={{
        p: 2,
        borderRadius: "16px",
        border: "1px solid #1A407D33",
        backgroundColor: "rgba(201, 222, 255, 1)",
        height: {
          xs: "auto",
          md: "100%",
        },
      }}
    >
      {/* Title */}
      <Typography
        sx={{
          fontSize: "14px",
          textAlign: "center",
          fontWeight: 600,
          mb: 1,
        }}
      >
        {title}
      </Typography>

      {/* Highlight */}
      {highlightRow && (
        <Typography
          sx={{
            fontSize: "32px",
            fontWeight: 700,
            color: "#1A407D",
            textAlign: "center",
            mb: 2,
          }}
        >
          {getDisplayValue(highlightRow.value)}
        </Typography>
      )}

      {/* White container */}
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          p: 2,
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 2,
          my: highlightRow ? 0 : 2.5,
        }}
      >
        {normalRows.map((row) => {
          const displayValue = getDisplayValue(row.value);
          const hasValue = displayValue !== "-";

          const isClickable =
            (row.clickable ?? false) && Boolean(row.onClick) && hasValue;

          const showTooltip = (row.clickable ?? false) && !hasValue;

          const valueNode = (
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 700,
                color: "#1A407D",
                cursor: isClickable ? "pointer" : "default",
                whiteSpace: "nowrap",
              }}
              onClick={isClickable ? row.onClick : undefined}
            >
              {displayValue}
            </Typography>
          );

          return (
            <Box
              key={row.label}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                pt: row.dividerTop ? 2 : 0,
                borderTop: row.dividerTop ? "1px dashed #D0D5DD" : "none",
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                {row.label}
              </Typography>

              {showTooltip ? (
                <Tooltip title="No records found">
                  <span>{valueNode}</span>
                </Tooltip>
              ) : (
                valueNode
              )}
            </Box>
          );
        })}
      </Box>
    </Stack>
  );
}

export default InfoCard;
